class Token {
  constructor() {
    this.token = null;
  }

  set(token) {
    this.token = token;
  }

  get() {
    return this.token;
  }

  has() {
    return this.token !== null;
  }

  forget() {
    return new Promise((resolve, reject) => {
      if (this.token) {
        window.Ajax.delete('/authenticate/token')
          .then(() => {
            this.token = null;
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      } else {
        resolve();
      }
    });
  }
}

export default Token;
